import React, { useContext, useEffect, useRef, useState } from 'react';
// const cityTimezones = require('city-timezones');
import { message } from 'antd';
import { LangContext } from '../../contexts/langContext';
import { StateContext } from '../../contexts/stateContext';
import { timezones } from '../../static/timezones';
import { ListCitiesPresets } from '../Lists/ListCity';
import {
  _getCity,
  checkProvince,
  fetchNearestCities,
  getGeoLocation,
  handleCitySearch
} from '../utilsGeo';
import { Button } from './Button';
import { Preloader, Preloader0 } from './kit';
import { SocialContext } from '../../contexts/socialContext';

// const cities = require('all-the-cities');


const getTimezone = (tz, what) => {
  let t = timezones.filter(one => one['utc'].includes(tz))
  t = t.length ? t[0] : {}
  return t[what]
}




export function CityLocate({
  children,
  buttonStyle = {},
  locateMe = false,
  autoFocus = false,
  placeholder,
  city = {},
  value = '',
  show = ['city', 'province', 'country', 'timezone', 'gmt'], //'province'
  inactive = false,
  setOffset = () => void (0),
  handleCityId = () => void (0),
  handleCityObj = () => void (0),
  handleEmpty = () => void (0),
  handleCityFocused,
  avatar = {},
  // className = 'ant-picker ant-picker-borderless'
  className = '',
  recents = false,
}) {

  const context = { ...useContext(LangContext), ...useContext(StateContext), ...useContext(SocialContext) };
  const $ui = context.$ui;


  placeholder = placeholder || $ui('avatar_city_placeholder');

  // const [city, setCity] = useState({})

  useEffect(() => {
    if (value) {
      _getCity(value, setCityObject)
    } else {
      setCityObject()
    }
  }, [value])

  useEffect(() => {
    if (city && cityObject && city.id && city.id !== cityObject.id) {
      setCityObject(city)
    }
  }, [city])

  useEffect(() => {
    if (!context.state.calcShown
      && city && cityObject && city.id && city.id !== cityObject.id) {
      setCityObject(city)
    }
  }, [city])

  useEffect(() => {
    if (context.me && cityObject && context.me.user.city_id !== cityObject.id && context.me.user.aggr.city) {
      setCityObject(context.me.user.aggr.city)
    }
  }, [context.me])

  const inputRef = useRef(null);



  const defaultCity = {
    "city": "Pavlodar",
    "city_ascii": "Pavlodar",
    "country": "Kazakhstan",
    "iso2": "KZ",
    "iso3": "KAZ",
    "lat": "52.29999758",
    "lng": "76.95002112",
    "pop": "316254",
    "province": "Pavlodar",
    "timezone": "Asia/Almaty"
  };





  const [fetching, setFetching] = useState(false);


  const [cityObject, setCityObject] = useState(city.id ? city : null);
  const [cityVariants, setCityVariants] = useState([]);

  const [searchValue, setSearchValue] = useState('');


  // const [selected, setSelected] = useState('');
  const [suggest, setSuggest] = useState([]);
  const [suggestShown, setSuggestShown] = useState(false);

  const [selectedCity, setSelectedCity] = useState(0)


  const cytySearch = (val, callback) => {
    setFetching(true)
    setSuggest([])
    setSuggestShown(true)
    handleCitySearch(val, searchCallBack)
    setSearchValue(val)
    if (val) {
      setSuggestShown(true)
    }
  }

  const searchCallBack = (newCities) => {
    setSuggest(newCities)
    setFetching(false)
  }

  const handleSelect = (one) => {
    setSearchValue('')
    setCityObject(one)
    setSuggestShown(false)
    setOffset(one.offset)
    handleCityId(one.id)
    handleCityObj(one)
  }

  const handleClear = () => {
    handleCityId()
    setCityObject()
    handleEmpty()
    setSuggestShown(true)
  }

  const useFocus = (context, handleCityFocused) => {
    const htmlElRef = useRef(null);

    const setFocus = () => {
      if (context.state.calcShown) {
        if (htmlElRef.current) {
          // console.log('htmlElRef.current = ', htmlElRef.current);
          htmlElRef.current.focus();
        }

        if (handleCityFocused && htmlElRef.current) {
          context.setState.setCitySearchActive(true);

          // Add blur event listener
          // htmlElRef.current.addEventListener('blur', () => {

          // });
        }
      }
    };

    return [htmlElRef, setFocus];
  };

  // Usage:
  const [cityInput, setInputFocus] = useFocus(context, handleCityFocused);



  // const cityInput = useRef();

  function findCityData(input) {
    // return input ? cityTimezones.lookupViaCity(input) : '';
  }

  function timeZonesToList(timezones) {
    let tz = []
    timezones.forEach(oneZ => (tz.push(...oneZ['utc'])))
    return tz;
  }


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        // setSelectedCity((prevSelectedCity) => (prevSelectedCity > -1 ? prevSelectedCity - 1 : -1));
        setSelectedCity(selectedCity - 1);
        // console.log('selectedCity = ', selectedCity);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        // setSelectedCity((prevSelectedCity) => (prevSelectedCity < suggest.length - 1 ? prevSelectedCity + 1 : prevSelectedCity));
        setSelectedCity(selectedCity + 1);
        // console.log('selectedCity = ', selectedCity);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  useEffect(() => {

    // console.log('suggest = ', suggest);
  }, [suggest])


  useEffect(() => {
    if (cityObject) {
      context.setState.setCitySearchActive(false);
    }
  }, [cityObject])

  useEffect(() => {
    if (!cityObject && autoFocus) {
      setInputFocus()
    } else {
      // handleFocused(false)
    }
    // if (cityInput.current) {
    //   cityInput.current.focus()
    // }
  })


  useEffect(() => {
    if (recents && !suggestShown) {
      // setSuggestShown(true)
    }
  }, [searchValue, cityObject])


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the component
      if (!event.target.closest(".__city_selector")) {
        setSuggestShown(false);
      }
    };

    const handleMouseMove = (event) => {
      // Check if the mouse is outside the component
      if (!event.target.closest(".__city_selector")) {
        setSuggestShown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      // document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);



  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null);



  const handleLocationClick = async () => {
    setLoading(true);
    try {
      const position = await getGeoLocation();
      const { latitude, longitude } = position.coords;
      console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
      const data = await fetchNearestCities(latitude, longitude);
      if (data.length) {
        setCityVariants(data);
        setCityObject(data[0]);
        handleCityId(data[0].id)
        handleCityObj(data[0])
        message.success(`${$ui('geo_found_you')} ${data[0].city}, ${Boolean(checkProvince(data[0].province)) ? `${data[0].province},` : ''} ${data[0].country}!`);
      } else {

      }
    } catch (error) {
      console.error('Error getting location:', error.message);
      message.error(error.message);
    } finally {
      setLoading(false); // Stop loading after cityObject is set or if an error occurs
    }
  };





  return (
    <>
      <Button
        {...buttonStyle}
        onClick={handleLocationClick}
        loading={loading}
        icon={'location_on'}
      >
        {children}
      </Button>
    </>
  );
}






export function OneCity({
  icon = '',
  show = ['city', 'province', 'country', 'timezone', 'gmt'],
  one,
  handleSelect,
  handleClear,
  className = '',
  active
}) {

  const gmt = (g) => g >= 0 ? `+${g}` : g;

  return (


    <div className={`x_input_drop_suggest ${className}`}
      style={{ minHeight: 24 }}
      onClick={() => handleSelect ? handleSelect(one) : void (0)}
    >

      <div className={`x_input_drop_li_1 ${className}`}>

        {Boolean(icon) && <div className='t_icon t_icon--40'>{icon}</div>}

        {show.includes('city') && <div className="x_input_drop_city">{one ? one['city'] : 'City'}</div>}
        <div className={`x_input_drop_country ${className}`}>{show.includes('province') && <>{one ? checkProvince(one['province']) : ''}</>} {show.includes('country') && <>{one ? one['country'] : ''}</>}</div>
        {(show.includes('timezone') || show.includes('gmt') || show.includes('offset')) && <div className={`x_input_drop_right  ${className}`}>
          <div className="x_input_drop_country">
            {show.includes('timezone') && <>{(one && one.timezone) ? one.timezone.replace('_', ' ') : ''}</>} {show.includes('gmt') && <>{one && `GMT${gmt(one['offset'])}`}</>}
          </div>
        </div>}


      </div>

      {handleClear &&
        <div className={`x_input_right x_input_right--city ${className}`}>
          <div className={`x_input_action ${className}`}
            // style={{}}
            onClick={handleClear}
          ><div className="t_icon t_icon--40"><div>close</div></div></div></div>}


    </div>


  )
}




